
export default function ExpertTeamSection() {
  const experts = [
    {
      name: "王茗轩",
      title: "首席茶艺师",
      experience: "30年茶行业经验",
      specialties: ["普洱茶品鉴", "茶艺培训", "收藏指导"],
      description: "国家一级茶艺师，中国茶叶学会资深会员，专注普洱茶研究30年",
      avatar: "https://public.readdy.ai/ai/img_res/201259f7e4b3e91e22c767b1fbe5d697.jpg"
    },
    {
      name: "李雅韵",
      title: "高级品鉴师",
      experience: "25年品鉴经验",
      specialties: ["茶叶品质评估", "市场分析", "投资咨询"],
      description: "国际茶叶品质认证师，茶叶拍卖行资深顾问，擅长茶叶投资分析",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20tea%20expert%20portrait%2C%20elegant%20middle-aged%20female%20specialist%20with%20sophisticated%20appearance%2C%20wearing%20modern%20business%20attire%2C%20confident%20and%20knowledgeable%20expression%2C%20tea%20plantation%20background%2C%20natural%20lighting%2C%20premium%20service%20ambiance&width=400&height=400&seq=expert-li&orientation=squarish"
    },
    {
      name: "张博文",
      title: "茶文化学者",
      experience: "20年文化研究",
      specialties: ["茶文化传承", "历史研究", "礼仪指导"],
      description: "茶文化博士，著名茶学院教授，致力于茶文化的传承与发展",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20tea%20culture%20scholar%20portrait%2C%20intellectual%20middle-aged%20male%20professor%20with%20scholarly%20appearance%2C%20wearing%20glasses%20and%20traditional%20scholar%20attire%2C%20surrounded%20by%20ancient%20tea%20books%20and%20artifacts%2C%20academic%20atmosphere%20with%20warm%20lighting&width=400&height=400&seq=expert-zhang&orientation=squarish"
    },
    {
      name: "陈怡然",  
      title: "养生茶疗师",
      experience: "15年中医茶疗",
      specialties: ["中医茶疗", "养生指导", "体质调理"],
      description: "中医药大学硕士，国家注册营养师，专业茶疗养生顾问",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20tea%20therapy%20specialist%20portrait%2C%20young%20female%20expert%20with%20gentle%20healing%20appearance%2C%20wearing%20white%20medical%20coat%2C%20surrounded%20by%20medicinal%20herbs%20and%20tea%20samples%2C%20clean%20medical%20environment%20with%20soft%20lighting&width=400&height=400&seq=expert-chen&orientation=squarish"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 标题区域 */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            专家团队
          </h2>
          <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto">
            汇聚行业顶尖专家，为您提供最权威、最专业的茶叶咨询服务
          </p>
        </div>

        {/* 专家网格 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {experts.map((expert, index) => (
            <div
              key={index}
              className="bg-gradient-to-b from-gray-50 to-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              {/* 专家头像 */}
              <div className="relative">
                <img 
                  src={expert.avatar}
                  alt={expert.name}
                  className="w-full h-64 object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>

              {/* 专家信息 */}
              <div className="p-6">
                <div className="text-center mb-4">
                  <h3 className="text-sm sm:text-lg md:text-xl font-bold text-[#663333] mb-1">
                    {expert.name}
                  </h3>
                  <p className="text-xs sm:text-sm text-[#cc9966] font-semibold mb-2">
                    {expert.title}
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600">
                    {expert.experience}
                  </p>
                </div>

                {/* 专业领域 */}
                <div className="mb-4">
                  <div className="flex flex-wrap gap-2 justify-center">
                    {expert.specialties.map((specialty, sIndex) => (
                      <span 
                        key={sIndex}
                        className="px-3 py-1 bg-[#cc9966]/10 text-[#663333] text-xs rounded-full border border-[#cc9966]/20"
                      >
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>

                {/* 简介 */}
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed mb-6">
                  {expert.description}
                </p>

                {/* 咨询按钮 */}
                <button className="w-full py-3 bg-[#663333] text-white rounded-lg hover:bg-[#552929] transition-colors duration-300 font-semibold text-xs sm:text-sm group-hover:bg-[#cc9966] whitespace-nowrap">
                  预约咨询
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* 团队优势 */}
        <div className="mt-16 lg:mt-20">
          <div className="bg-gradient-to-r from-[#663333] to-[#775544] rounded-2xl p-8 lg:p-12 text-center">
            <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-white mb-6">
              为什么选择我们的专家团队？
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 text-white">
              <div className="space-y-3">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-[#cc9966] rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-award-fill text-lg sm:text-xl md:text-2xl text-white"></i>
                </div>
                <h4 className="text-sm sm:text-base md:text-lg font-semibold">权威认证</h4>
                <p className="text-xs sm:text-sm opacity-90">
                  所有专家均持有国家级茶艺师、品鉴师等权威认证
                </p>
              </div>
              
              <div className="space-y-3">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-[#cc9966] rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-time-fill text-lg sm:text-xl md:text-2xl text-white"></i>
                </div>
                <h4 className="text-sm sm:text-base md:text-lg font-semibold">丰富经验</h4>
                <p className="text-xs sm:text-sm opacity-90">
                  平均20年以上行业经验，服务过数千位茶友
                </p>
              </div>
              
              <div className="space-y-3">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-[#cc9966] rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-heart-fill text-lg sm:text-xl md:text-2xl text-white"></i>
                </div>
                <h4 className="text-sm sm:text-base md:text-lg font-semibold">贴心服务</h4>
                <p className="text-xs sm:text-sm opacity-90">
                  一对一专属服务，全程跟踪指导，确保满意效果
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
